/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.controllers {

    export interface IDocumentationScope extends angular.IScope {
        model: models.DocumentationModel;
    }

    export class DocumentationController implements IController {
        scope: IDocumentationScope;

        constructor(
            $scope: IDocumentationScope,
            $rootScope: ng.IRootScopeService,
            $routeParams: angular.route.IRouteParamsService,
            $location: ng.ILocationService,
            $anchorScroll: ng.IAnchorScrollService,
            processConfigurationService: warsApp.services.ProcessConfigurationService,
            processTypeService: warsApp.services.ProcessTypeService,
            workflowService: warsApp.services.WorkflowService,
            workflowDrawingService: warsApp.services.WorkflowDrawingService,
            conditionService: warsApp.services.ConditionService,
            emailConfigurationService: warsApp.services.EmailConfigurationService,
            pdfBindingService: warsApp.services.PdfBindingService,
            modalService: any)
        {
            var processConfigId = $routeParams["id"];
            var anchor = $routeParams["anchor"];
            this.scope = $scope;
            this.scope.model = new models.DocumentationModel(
                processConfigId,
                anchor,
                $location,
                $anchorScroll,
                $scope,
                $rootScope,
                processConfigurationService,
                processTypeService,
                workflowService,
                workflowDrawingService,
                conditionService,
                emailConfigurationService,
                pdfBindingService,
                modalService);
        }
    }
}

warsApp.registerController('DocumentationController',
    [
        '$scope', '$rootScope', '$routeParams', '$location', '$anchorScroll',
        'processConfigurationService', 'processTypeService', 'workflowService', 'workflowDrawingService', 'conditionService', 'emailConfigurationService', 'pdfBindingService',
        'ModalService'
    ]);